// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ekuZ","left":"styles_left__3FBD1"};